import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: false,
  sliderValue: null,
};

const playbackSlice = createSlice({
  name: "playback",
  initialState,
  reducers: {
    setPlaybackStatus: (state, action) => {
      state.status = action.payload;
    },
    setSliderTime: (state, action) => {
      state.sliderValue = action.payload;
    },
  },
});

export const { setPlaybackStatus, setSliderTime } = playbackSlice.actions;
export default playbackSlice.reducer;
